import request from "../helpers/request";

/** Listado de subroles del grupo (contexto del token). */
export async function GetSubroles() {
  try {
    const response = await request("/subrole/list", {});
    const data = response.data || {};
    return {
      subroles: data.subroles || data.roles || []
    };
  } catch (err) {
    throw err;
  }
}

export async function CreateSubrole(subroleData) {
  try {
    const body = {
      name: subroleData.name,
      description: subroleData.description,
      policies: subroleData.policies || {},
      baseRole: subroleData.baseRole,
      slug: subroleData.slug
    };
    const response = await request("/subrole/create", body);
    const d = response.data || {};
    return {
      subrole: d.subrole || d.role || {}
    };
  } catch (err) {
    throw err;
  }
}

export async function UpdateSubrole(payload) {
  try {
    const response = await request("/subrole/update", payload);
    const data = response.data || {};
    return {
      subrole: data.subrole || data.role || data.Role || {}
    };
  } catch (err) {
    throw err;
  }
}

export async function DeleteSubrole(subroleId) {
  try {
    const response = await request("/subrole/delete", { subroleId });
    return {
      message:
        response.data?.Message ||
        response.data?.message ||
        "Subrol eliminado correctamente"
    };
  } catch (err) {
    throw err;
  }
}

/**
 * Asigna o quita el subrol del usuario.
 * `subroleId` null quita el subrol personalizado; el rol principal no se modifica.
 */
export async function AssignSubrole(userId, subroleId) {
  try {
    const response = await request("/subrole/assign", {
      userId,
      subroleId
    });
    return {
      user: response.data?.user || {}
    };
  } catch (err) {
    throw err;
  }
}
